import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AdalService } from './../azure-authentication/adal.service';
import { UserService } from '../../users/user.service';

@Injectable()
export class OAuthCallbackHandler implements CanActivate {

    constructor(private router: Router,
                private adalService: AdalService,
                private userService: UserService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        this.adalService.handleCallback();

        if (this.adalService.userInfo) {
            var returnUrl = route.queryParams['returnUrl'];

            if (!returnUrl) {
                this.router.navigate(['home']);
            } else {
                this.router.navigate([returnUrl], { queryParams: route.queryParams });
            }
        }
        else {
            this.router.navigate(['login']);
        }

        return false;
    }

} 



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/shared/login-callback/oauth-callback.guard.ts